module.exports = __webpack_public_path__ + "0c29bf4dbbe2904678b890250dd77119.png";